import script from "./ToggleTaskTimeValidatedAtAction.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleTaskTimeValidatedAtAction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__